import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');
require('./style.css');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalCookiePolicyEN extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Cookie Policy';
		const siteDescription = 'CookiePolicy description';
		const siteKeywords = 'CookiePolicy default keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/cookiepolicy/en';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Cookie Policy</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageHeaderSection>
						<p>
							This Cookie Policy, together with Website Terms of Use and Privacy Policy, governs the use of Cookies by
							Glossiq d.o.o., with registered address at Velika pot 15, 5250 Solkan, Slovenia ("Glossiq", "Us") in
							connection to access and use of the Website.
						</p>

						<p>
							Following the EU regulations, GLOSSIQ uses cookies on the website located at www.glossiq.com and any other
							subsite ("the Website") to provide better user experience, security, smooth function of web portal and to
							monitor site visit statistics. We save mandatory cookies that are necessary for the website to run
							effortlessly, and we give you choices regarding other types of cookies.
						</p>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<InfoPageTitle1>What are cookies?</InfoPageTitle1>

						<p>
							Cookies are small text files most sites store on devices that allow users to access the Internet to
							identify them. The storage of cookies is under the full control of the browser that the user has — it can
							limit or disable cookies storage.
						</p>

						<InfoPageTitle1>GLOSSIQ uses three groups of cookies:</InfoPageTitle1>

						<ul>
							<li>
								Necessary Cookies: They are required for the site to function properly. They set up when you log into
								the Customer Portal or interact with any website that opens by clicking on links. We do not need to
								obtain your consent for these cookies under GDPR.
							</li>
							<li>
								Analytic Cookies: These cookies are used to analyse the visits to our site. Data is captured
								anonymously. This cookie group is automatically downloaded, and we do not need to obtain your consent
								under GDPR.
							</li>
							<li>
								Marketing Cookies: These cookies are for marketing purposes and are used to track users when they visit
								different websites. They are designed to show relevant and engaging ads to the individual user, as well
								as to prevent ads that the user has already seen. This information is collected in a non-personal form.
							</li>
						</ul>

						<p>
							If you agree to the installation of all cookies click "I agree". You can change your choice at any time.
						</p>

						<InfoPageTitle1>Why are cookies needed?</InfoPageTitle1>

						<p>
							They are fundamental to providing user-friendly online services. The interaction between the web user and
							the website is faster and easier with the help of cookies. With their help, the site remembers the user's
							preferences and experiences, saves time and makes browsing the sites more efficient and friendly.
						</p>

						<p>Here are some specific examples of Cookies:</p>

						<ul>
							<li>to improve the user experience of the website, and show visitors content based on past visits;</li>
							<li>to store choice when creating shortlisted devices and offers, and when comparing them;</li>
							<li>to keep you logged in on parts of websites where sign-in is required;</li>
							<li>
								to identify device (computer, tablet, cell phone) and to customize the content displayed to your device;
							</li>
							<li>
								to monitor the visit, to check the effectiveness of content delivery and the relevance of ads, and to
								continually improve web pages;
							</li>
							<li>
								certain cookies are necessary for the functioning of certain services (f.e., electronic registration of
								selected packages and other forms of e-commerce, …)
							</li>
						</ul>

						<InfoPageTitle1>Rejection of the use of Cookies</InfoPageTitle1>

						<p>
							You may at any time reject the use of Cookies that are not strictly necessary for the functioning of the
							Website either through cookie settings available on the Website or through cookie settings available in
							your browser. If you reject the use of some or all Cookies that are not strictly necessary for the
							functioning of the Website, you may experience reduced efficiency of the functioning of the Website and
							deletion of your selection of settings and preferences.
						</p>

						<p>
							Cookie settings available on the Website may be managed in the pop-up bar or at the bottom of the website.
						</p>

						<p>
							Alternatively, you can manage the use of some or all Cookies that are not strictly necessary for the
							functioning of the Website through cookie settings embedded in your browser in accordance with the
							following instructions:
						</p>

						<ul>
							<li>
								Instructions to manage cookies in{' '}
								<a href="https://support.google.com/accounts/answer/61416" target="_blank" rel="noreferrer">
									Google Chrome
								</a>
								;
							</li>
							<li>
								Instructions to manage cookies in{' '}
								<a
									href="https://support.mozilla.org/en-US/products/firefox/protect-your-privacy/cookies"
									target="_blank"
									rel="noreferrer"
								>
									Mozilla Firefox
								</a>
								;
							</li>
							<li>
								Instructions to manage cookies in{' '}
								<a
									href="https://support.microsoft.com/en-gb/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
									target="_blank"
									rel="noreferrer"
								>
									Microsoft Edge
								</a>
								;
							</li>
							<li>
								Instructions to manage cookies in{' '}
								<a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">
									Safari
								</a>
								.
							</li>
						</ul>

						<InfoPageTitle1>Modifications to this Cookie Policy</InfoPageTitle1>

						<p>
							Glossiq reserves the right to modify these Website Terms of Use at any time. The modified Cookie Policy
							governs the use of Cookies from the moment of its publication on the Website.
						</p>

						<InfoPageTitle1>Contact Us</InfoPageTitle1>

						<p>Don't hesitate to contact us if you have any questions.</p>

						<p>
							Via Email: <a href="mailto:support@glossiq.com">support@glossiq.com</a>
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalCookiePolicyEN };
